import arrowSymbolsJson from "./arrow-symbols.json";
import calculusSymbolsJson from "./calculus-symbols.json";
import circledSymbolsJson from "./circled-symbols.json";
import doubleStrokeSymbolsJson from "./double-stroke-symbols.json";
import greekItalicJson from "./greek-italic.json";
import greekSymbolsJson from "./greek-symbols.json";
import italicSymbolsJson from "./italic-symbols.json";
import logicSymbolsJson from "./logic-symbols.json";
import operatorSymbolsJson from "./operator-symbols.json";
import otherSymbolsJson from "./other-symbols.json";
import relationOperatorJson from "./relation-operator-symbols.json";
import scriptSymbolsJson from "./script-symbols.json";
import serifSymbolsJson from "./serif-symbols.json";
import setSymbolsJson from "./set-symbols.json";

export type SymbolItem = {
  name: string;
  symbol: string;
  category?: string | string[];
  keywords?: string[] | Record<string, number>;
  sidebarGroupKey?: string;
  groupIndex?: number;
};

export { doubleStrokeSymbolsJson };

export const doubleStrokeSymbols = doubleStrokeSymbolsJson as SymbolItem[];
export const arrowSymbols = arrowSymbolsJson as SymbolItem[];
export const greekSymbols = greekSymbolsJson as SymbolItem[];
export const relationOperatorSymbols = relationOperatorJson as SymbolItem[];
export const operatorSymbols = operatorSymbolsJson as SymbolItem[];
export const calculusSymbols = calculusSymbolsJson as SymbolItem[];
export const otherSymbols = otherSymbolsJson as SymbolItem[];
export const logicSymbols = logicSymbolsJson as SymbolItem[];
export const setSymbols = setSymbolsJson as SymbolItem[];
export const circledSymbols = circledSymbolsJson as SymbolItem[];
export const serifSymbols = serifSymbolsJson as SymbolItem[];
export const italicSymbols = italicSymbolsJson as SymbolItem[];
export const greekItalicSymbols = greekItalicJson as SymbolItem[];
export const scriptSymbols = scriptSymbolsJson as SymbolItem[];
